import React from 'react';
import { useLocation } from 'react-router-dom';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const CouponDisplay = () => {
  const query = useQuery();
  const couponCode = query.get('code');

  return (
    <>
     <meta name="robots" content="noindex, nofollow" />
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '200px 0' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '20px' }}>🎉 Your Coupon Code</h1>
      {couponCode ? (
        <div style={{
          fontSize: '2.5rem',
          color: 'green',
          fontFamily: 'monospace',
          backgroundColor: '#fff',
          padding: '20px 40px',
          borderRadius: '10px',
          boxShadow: '0 0 10px rgba(0,0,0,0.1)'
        }}>
          {couponCode}
        </div>
      ) : (
        <p style={{ fontSize: '1.2rem', color: '#555' }}>No coupon code found</p>
      )}
    </div>
    </>
  );
};

export default CouponDisplay;
